// export const SERVICE_URL = "http://localhost:3001";
// export const SERVICE_URL = "http://192.168.0.166:5005";
export const SERVICE_URL = "https://v1api.yfosclean.com";
//export const SERVICE_URL = "http://13.51.67.242:5006";
// export const SERVICE_URL = "http://142.132.224.108:3004/api/v1";
export const ALLOWED_IMAGE_SIZE_IN_BYTES = 12000000;

export const validFileTypes = ["image/jpeg", "image/png", "application/pdf"];
export const validFileSize = 1 * 1024 * 1024;
